import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "common-move",
  "use": "common-move-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"common-move\"><rect x=\"4\" y=\"4\" width=\"12\" height=\"2\" /><rect x=\"4\" y=\"9\" width=\"12\" height=\"2\" /><rect x=\"4\" y=\"14\" width=\"12\" height=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol